"use client";

import TechnologiesSection from "@/app/components/TechnologiesSection";
import PageSection from "@/app/components/PageSection";
import SectionTitle from "@/app/components/SectionTitle";
import GlassCard from "@/app/components/GlassCard";
import PageCta from "@/app/components/PageCta";
import { CONTACTS } from "@/lib/site-contacts";
import { useLocale } from "@/app/components/LocaleProvider";
import { getPathWithLocale } from "@/lib/i18n";
import { stackCategories } from "@/lib/technologies-stack";

/**
 * Направления стека. Раньше это были карточки с эмодзи, у которых часть глифов
 * рисовалась монохромно, и заголовок «Базы данных» показывался даже на английской
 * версии. Теперь это обычные стеклянные карточки с локализованными названиями,
 * а сам список стека живёт в lib/technologies-stack и переиспользуется ассистентом.
 */
export default function TechnologiesClient() {
    const locale = useLocale();
    const isEn = !locale.startsWith("ru");
    const items = stackCategories(locale);

    return (
        <>
            <PageSection>
                <TechnologiesSection />
            </PageSection>

            <PageSection>
                <SectionTitle
                    title={isEn ? "Focus areas" : "Направления"}
                    description={
                        isEn
                            ? "What we build with this stack, from interfaces to infrastructure."
                            : "Что мы собираем на этом стеке — от интерфейсов до инфраструктуры."
                    }
                />
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {items.map((category) => (
                        <GlassCard key={category.key}>
                            <h3 className="text-base font-semibold text-white">{category.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-white/60">{category.items.join(", ")}</p>
                        </GlassCard>
                    ))}
                </div>
            </PageSection>

            <PageCta
                title={isEn ? "Need a team for this stack?" : "Нужна команда под этот стек?"}
                description={
                    isEn
                        ? "Tell us about the project — we will suggest the stack, the timeline and the team."
                        : "Расскажите о проекте — предложим стек, сроки и состав команды."
                }
                actions={[
                    {
                        href: getPathWithLocale("/book-call?source=technologies", locale),
                        label: isEn ? "Discuss a project" : "Обсудить проект",
                        primary: true,
                        ctaLocation: "pagecta_technologies_primary",
                    },
                    {
                        href: CONTACTS.telegramUrl,
                        label: isEn ? "Message on Telegram" : "Связаться в Telegram",
                        ctaLocation: "pagecta_technologies_secondary",
                    },
                ]}
            />
        </>
    );
}
